enum TimesheetStatus {
	Pending = 10,
	Approved = 90,
	Cancelled = 100,
}

export default TimesheetStatus;